import React from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography,} from '@mui/material';
import RotateRightIcon from '@mui/icons-material/RotateRight';

interface StatusChangeModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export default function StatusChangeModal({
                                              open,
                                              onClose,
                                              onConfirm,
                                          }: StatusChangeModalProps) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth='sm'
            fullWidth
            PaperProps={{
                className: 'modal-dialog'
            }}
        >
            <DialogTitle>
                Status ändern
            </DialogTitle>
            <DialogContent className="modal-content">
                <Typography className="modal-content-text">
                    Sie sind als Verantwortlicher für diese Aufgabe zugewiesen und öffnen sie zum ersten
                    Mal.
                </Typography>
                <Typography className="modal-content-text">
                    Möchten Sie den Status automatisch auf <strong>"In Bearbeitung"</strong> setzen?
                </Typography>
                <Box className="modal-info-box">
                    <Typography className="modal-box-text modal-box-text-info">
                        Dies hilft anderen zu sehen, dass Sie an der Aufgabe arbeiten.
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions className="modal-actions" sx={{flexWrap: 'wrap'}}>
                <Button
                    onClick={onClose}
                    className="modal-button modal-button-cancel"
                >
                    Nein, Status beibehalten
                </Button>
                <Button
                    onClick={onConfirm} variant='contained'
                    className="modal-button modal-button-primary"
                >
                    <RotateRightIcon className="modal-icon"/>
                    Ja, auf "In Bearbeitung" setzen
                </Button>
            </DialogActions>
        </Dialog>
    );
}
